"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _default = function _default() {
  let prefix = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return [_react.default.createElement("path", {
    d: "M12.8554 13.1371c.5451 0 .9869-.4539.9869-1.0139 0-.5599-.4418-1.0139-.9869-1.0139-.545 0-.9868.454-.9868 1.0139 0 .56.4418 1.0139.9868 1.0139z"
  }), _react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.482 4.984C8.8217 4.3944 5.1612 5.125 2 7.5606v11.9536l4.702-1.2432c4.4333 2.8699 9.5759 1.7557 13.8649-.3656L22 13.5102l-3.5036-1.1998-1.2466-2.643c1.1108-1.6615 1.316-3.6816 1.316-5.6503-2.0606-.0004-4.2709-.225-6.0838.9668zm4.0411 1.0604c-.1824 1.3089-.7272 2.3614-1.621 3.2955l2.181 4.6239 2.4175.8279-.5391 1.6534c-4.0028 1.8964-8.3157 2.1429-11.8969-.3637l-3.0909.8172V8.5872c2.7325-1.9325 5.8286-2.0295 8.9921-1.4616 1.0962-.8454 2.1882-1.0722 3.5573-1.0812z"
  })];
};

exports.default = _default;